const menus = [
  {
    id: 1,
    name: 'Home',
    links: '/',
  },
  {
    id: 2,
    name: 'Explore',
    links: '#',
    namesub: [
      {
        id: 1,
        sub: 'Upcoming Events',
        links: '/events',
      },
      {
        id: 2,
        sub: 'SHOP',
        links: 'https://shop.nxtlvlnights.com/',
      },
      /*   {
                id: 3,
                sub: 'VIP Experience',
                links: '/blog-details'
            },
            {
                id: 4,
                sub: 'Past Highlights',
                links: '/visions-mission'
            },
            {
                id: 5,
                sub: 'Promoters',
                links: '/help-center'
            },
            {
                id: 6,
                sub: 'The Movement',
                links: '/participants-assets'
            },
            {
                id: 7,
                sub: 'Sponsors',
                links: '/advisors-backers'
            },
            {
                id: 8,
                sub: 'Partners',
                links: '/partners'
            } 
      */
    ],
  },
  {
    id: 4,
    name: 'About',
    links: '/about',
  },
  {
    id: 5,
    name: 'RoadMap',
    links: '/road-map',
  },
  {
    id: 6,
    name: 'Team',
    links: '/team',
  },
  {
    id: 7,
    name: 'Contact',
    links: '/contact',
  },
];

export default menus;
